import { render, staticRenderFns } from "./SavedAnchorPage.vue?vue&type=template&id=f101f372&scoped=true"
import script from "./SavedAnchorPage.vue?vue&type=script&lang=js"
export * from "./SavedAnchorPage.vue?vue&type=script&lang=js"
import style0 from "./SavedAnchorPage.vue?vue&type=style&index=0&id=f101f372&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f101f372",
  null
  
)

export default component.exports